import { HomeOutlined, SettingOutlined } from "@ant-design/icons";
import { Breadcrumb, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { checkIsAdmin } from "../../store/actions/auth.action";
import { createBreadCrumbFromUrl, getDefaultLanguage } from "../../utils/functions";
import Navbar from "./Navbar";
import styles from "./index.module.css";

const { Sider, Content } = Layout;
const { SubMenu, Item: MenuItem } = Menu;

function getItem(label, key, icon, href, children) {
  return {
    key,
    icon,
    children,
    label,
    href,
  };
}

const checkItem = (url, items) => {
  for (let i = 0; i < items.length; i++) {
    if (items[i].children) {
      return checkItem(url, items[i].children);
    }
    if (url === items[i].href || url.includes(items[i].href)) {
      return items[i].key;
    }
  }

  return null;
};

const AuthLayout = ({ children, needsAdmin }) => {
  const { isAdmin, token } = useSelector((state) => state.auth);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [defaultSelectedKey, setDefaultSelectedKey] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { t } = useTranslation();

  const itemsAmin = [
    getItem(t("auth.sidebar.home"), "1", <HomeOutlined />, "/home-sso"),
    getItem(t("auth.sidebar.admin"), "5", <SettingOutlined />, "/admin", [
      getItem(t("auth.sidebar.admins"), "2", null, "/admin/admins"),
      getItem(t("auth.sidebar.networks"), "3", null, "/admin/networks"),
      getItem(t("auth.sidebar.users"), "4", null, "/admin/users"),
    ]),
  ];

  const itemsNotAdmin = [getItem(t("auth.sidebar.home"), "1", <HomeOutlined />, "/home-sso")];

  const [items, setItems] = useState(itemsNotAdmin);

  useEffect(() => {
    if (sessionStorage.getItem("language") === null || sessionStorage.getItem("language") === undefined) {
      sessionStorage.setItem("language", getDefaultLanguage());
    }
    setDefaultSelectedKey(checkItem(location.pathname, items));
    setBreadcrumbs(createBreadCrumbFromUrl(location.pathname));
  }, [defaultSelectedKey, dispatch, items, location.pathname]);

  useEffect(() => {
    setBreadcrumbs(createBreadCrumbFromUrl(location.pathname));
  }, [history, location.pathname]);

  useEffect(() => {
    if (token && !isAdmin) {
      dispatch(
        checkIsAdmin((res) => {
          if (!res && needsAdmin) {
            history.replace("/home-sso");
          }
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isAdmin, token]);

  useEffect(() => {
    if (isAdmin) {
      setItems(itemsAmin);
    } else {
      setItems(itemsNotAdmin);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, t]);

  return (
    <Layout>
      <Navbar />
      <Layout hasSider>
        <Sider
          width={200}
          className={styles.sider}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
          }}
        >
          <Menu
            mode="inline"
            defaultSelectedKeys={[1]}
            selectedKeys={[defaultSelectedKey]}
            style={{
              height: "100%",
              borderRight: 0,
              paddingTop: "16px",
            }}
          >
            {items.map((item) =>
              !item.children ? (
                <MenuItem key={item.key} icon={item.icon}>
                  <Link to={item.href}>{item.label}</Link>
                </MenuItem>
              ) : (
                <SubMenu
                  key={item.key}
                  icon={item.icon && item.icon}
                  title={
                    <span>
                      <span>{item.label}</span>
                    </span>
                  }
                >
                  {item.children.map((child) => (
                    <MenuItem key={child.key}>
                      <Link to={child.href}>{child.label}</Link>
                    </MenuItem>
                  ))}
                </SubMenu>
              )
            )}
          </Menu>
        </Sider>
        <Layout style={{ padding: "0px 32px 32px", marginLeft: "200px" }} className={styles.layout__body}>
          <Breadcrumb
            style={{
              margin: "16px 0",
              textAlign: "left",
            }}
          >
            {breadcrumbs.map((breadcrumb) => (
              <Breadcrumb.Item key={breadcrumb.key}>
                {breadcrumb.name === "admin" || breadcrumb.name === "edit" || breadcrumb.name === "add" ? (
                  t(`auth.breadcrumbs.${breadcrumb.name}`, breadcrumb.name)
                ) : (
                  <Link to={breadcrumb.path}>{t(`auth.breadcrumbs.${breadcrumb.name}`, breadcrumb.name)}</Link>
                )}
              </Breadcrumb.Item>
            ))}
            {/* <Breadcrumb.Item>Accueil</Breadcrumb.Item> */}
          </Breadcrumb>
          <Content>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AuthLayout;
